import React from "react";
import RtdIASImg from "../../../Assets/Images/our-team/Ranjan Das.png";

const OurTeaminfoContainer1 = () => {
  return (
    <div className="w-full overflow-hidden">
      <div
        className="bg-[#ECF8FB] px-4 sm:px-6 md:px-10 py-8 md:py-12"
        data-aos="fade-up"
        data-aos-duration="800"
      >
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 lg:gap-8 items-center">
            {/* Image Section */}
            <div
              className="lg:col-span-1 flex justify-center lg:justify-start  h-full"
              data-aos="fade-down"
              data-aos-delay="150"
            >
              <div className="relative overflow-hidden rounded-lg shadow-lg w-full h-full  lg:max-w-none">
                <img
                  src={RtdIASImg}
                  alt="Rtd.IAS Ranjan Das"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            {/* Content Section */}
            <div
              className="lg:col-span-3 order-1 lg:order-2"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              <div className="space-y-4 lg:space-y-6">
                <p className="text-[#585858] text-[16px] sm:text-[17px] lg:text-[18px] leading-relaxed font-normal text-justify break-words">
                  Shri Ranjan Kumar Das, a retired IAS officer, has made an
                  indelible mark on public administration through his
                  distinguished career. Starting as Sub-Collector in Kendrapada,
                  he adeptly tackled local issues and spearheaded developmental
                  initiatives. As Collector of Jajpur, he improved district
                  administration and service delivery, while his role as
                  Secretary of the Bhubaneswar Development Authority saw
                  significant strides in urban planning and modernization.
                </p>

                <p className="text-[#585858] text-[16px] sm:text-[17px] lg:text-[18px] leading-relaxed font-normal text-justify break-words">
                  In the Culture Department, Shri Das dedicated himself to
                  preserving and promoting regional cultural heritage. His
                  tenure as Chief Administrator of the Jagannath Temple was
                  marked by efficient management of the temple operations,
                  ensuring a smooth experience for millions of devotees. His
                  final role as Revenue Divisional Commissioner for South and
                  Central Division involved overseeing development activities
                  across several districts, fostering balanced regional growth.
                  He writes regularly for various Odia newspapers and has
                  represented Odisha in numerous national and international
                  literary forums.
                </p>

                <div
                  className="mt-6 lg:mt-8"
                  data-aos="fade-down"
                  data-aos-delay="450"
                >
                  <h2 className="text-[22px] sm:text-[24px] lg:text-[26px] text-[#08121A] font-bold mb-2">
                    MR. RANJAN KUMAR DAS
                  </h2>
                  <p className="text-[16px] sm:text-[17px] lg:text-[18px] text-[#08121A] font-medium">
                    Chief advisor
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurTeaminfoContainer1;
